import { ChevronRightIcon } from "@heroicons/react/24/solid";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import DropdownResults from "../DropdownResults/DropdownResults";

import "./styles/Select.scss";

interface IProps {
    name: string;
    options: Item[];
    onChange: (index: any | string) => void;
    defaultSelected?: string;
}
type Item = {
    id: string;
    name: string;
};
/**
 * Select Component + dropdown controlled component
 * @param name	  The name of the input for the form
 * @param options The options that will be displayed in the dropdown. For ex:  {name: "Martine", id: '123-abcd'}
 * @param onChange The function called when an option is clicked. It will be called with its id as a parameter
 * @param defaultSelected Optional  The id s of the option to show as selected by default
 */
const Select = ({
    name,
    options,
    onChange,
    defaultSelected = undefined,
}: IProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const hiddenInput = useRef<HTMLSelectElement>(null);
    const visibleInput = useRef<HTMLInputElement>(null);

    function handleSelect(opt: Item) {
        hiddenInput.current!.value = `${opt.id}`;
        visibleInput.current!.value = opt.name;

        onChange(opt.id as string);
        setIsOpen(false);
    }
    function handleClick(e: React.MouseEvent) {
        e.preventDefault();
        e.stopPropagation();
        setIsOpen(!isOpen);
        if (!isOpen == false) {
            document.removeEventListener("click", closeOnClick);
        } else {
            document.addEventListener("click", closeOnClick);
        }
    }
    useEffect(() => {
        if (defaultSelected) {
            const selected = options.find((opt) => opt.id == defaultSelected);
            selected && handleSelect(selected);
        }
    }, [defaultSelected]);
    function closeOnClick() {
        setIsOpen(false);
        document.removeEventListener("click", closeOnClick);
    }

    return (
        <>
            <select
                name={`${name}-html`}
                className="hidden a11y"
                ref={hiddenInput}
            >
                {options.map((opt) => {
                    return (
                        <option key={opt.id} value={opt.id}>
                            {opt.name}
                        </option>
                    );
                })}
            </select>
            <div className="select" onClick={(e) => handleClick(e)}>
                <input
                    className="input__input select__input"
                    name={name}
                    readOnly
                    aria-hidden={true}
                    ref={visibleInput}
                />
                <div className={`select__input__caret ${isOpen && "open"}`}>
                    <ChevronRightIcon className="icon--xs" />
                </div>
                {isOpen && (
                    <DropdownResults>
                        {options.map((opt) => {
                            return (
                                <li
                                    key={opt.id}
                                    value={opt.id}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();

                                        handleSelect(opt);
                                    }}
                                >
                                    {opt.name}
                                </li>
                            );
                        })}
                    </DropdownResults>
                )}
            </div>
        </>
    );
};
export default Select;
